<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57 5H7a2 2 0 00-2 2v50a2 2 0 002 2h50a2 2 0 002-2V7a2 2 0 00-2-2zm-1 51H8V8h48z"/></svg>